import React, { Component } from 'react'
import {
    Card,
    Row,
    Col,
    Button,
    Descriptions,
    Divider,
    Tag,
    message
} from 'antd'
import styled from 'styled-components'
import {
    SyncOutlined,
    DownloadOutlined,
    ClockCircleOutlined
} from '@ant-design/icons'
import { getThemeUpdate } from '../../services/apiServices'
import LoadingModal from '../../commons/Modal/Loading'

const Container = styled(Card)``

class ThemeUpdate extends Component {
    state = {
        isLoading: false,
        info: {}
    }

    componentDidMount() {
        this.getThemeUpdate()
    }

    async getThemeUpdate() {
        this.setState({ isLoading: true })
        try {
            let info = await getThemeUpdate()
            this.setState({
                isLoading: false,
                info: info.data
            })
        } catch (error) {
            this.setState({ isLoading: false })
            message.error(this.props.T('SOMETHING_WRONG'))
        }
    }

    render() {
        let { T, langSlug } = this.props
        let { info, isLoading } = this.state

        let isUpToDate = info.version == window.config.themeVersion

        return (
            <Container
                title={
                    <span className="text-xl">
                        <SyncOutlined /> {T('THEME_UPDATE')}
                    </span>
                }>
                {!isLoading && (
                    <>
                        <Row justify="center">
                            <Col md={{ span: 24 }} lg={{ span: 12 }}>
                                <Descriptions
                                    bordered
                                    column={{
                                        xxl: 1,
                                        xl: 1,
                                        lg: 1,
                                        md: 1,
                                        sm: 1,
                                        xs: 1
                                    }}>
                                    <Descriptions.Item label={T('THEME_NAME')}>
                                        {info.name}
                                    </Descriptions.Item>
                                    <Descriptions.Item
                                        label={T('LATEST_VERSION')}>
                                        {info.version} &nbsp;
                                        {isUpToDate ? (
                                            <Tag color="green">
                                                {T('ALREADY_UPDATE_THEME')}
                                            </Tag>
                                        ) : (
                                            <Tag color="gold">
                                                {T('YOUR_THEME_VERSION', {
                                                    version:
                                                        window.config
                                                            .themeVersion
                                                })}
                                            </Tag>
                                        )}
                                    </Descriptions.Item>
                                    <Descriptions.Item
                                        label={T('LAST_UPDATED')}>
                                        <ClockCircleOutlined /> {info.date}
                                    </Descriptions.Item>
                                    <Descriptions.Item label={T('DETAIL')}>
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: info.detail || '-'
                                            }}
                                        />
                                    </Descriptions.Item>
                                    <Descriptions.Item label={T('DOWNLOAD')}>
                                        {info.url ? (
                                            <Button
                                                type="primary"
                                                shape="round"
                                                icon={<DownloadOutlined />}
                                                onClick={() =>
                                                    window.open(
                                                        info.url,
                                                        '_blank'
                                                    )
                                                }>
                                                {T('DOWNLOAD')}
                                            </Button>
                                        ) : (
                                            '-'
                                        )}
                                    </Descriptions.Item>
                                </Descriptions>
                            </Col>
                        </Row>
                        {info.announcement && (
                            <>
                                <Divider />
                                <Row justify="center">
                                    <Col md={{ span: 24 }} lg={{ span: 12 }}>
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: info.announcement
                                            }}
                                        />
                                    </Col>
                                </Row>
                            </>
                        )}
                    </>
                )}

                <LoadingModal isOpen={this.state.isLoading} />
            </Container>
        )
    }
}

export default ThemeUpdate
